import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  OnInit
} from '@angular/core';
import { Roles } from '@app/models/user';
import * as rolesUtils from '@app/role.utils';

interface Link {
  url?: string;
  text: string;
  activeOptions?: any;
  dropdown?: boolean;
  show: boolean;
  links?: Link[];
}

@Component({
  selector: 'app-follow-header',
  templateUrl: './follow-header.component.html',
  styleUrls: ['./follow-header.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FollowHeaderComponent implements OnInit {
  @HostBinding('class')
  classes = 'navbar navbar-light bg-light navbar-fixed-top navbar-expand-md';

  @Input()
  me;

  @Input()
  follow;

  isNavbarCollapsed = true;

  get isCountryManager() {
    return this.me && this.me.role && rolesUtils.isCountryManager(this.me.role);
  }

  get isPlanner() {
    return this.me && this.me.role && rolesUtils.isPlanner(this.me.role);
  }

  get isComex() {
    return this.me && this.me.role === Roles.Comex;
  }

  get isComexCountry() {
    return this.me && this.me.role === Roles.ComexCountry;
  }

  get isSar() {
    return this.me && this.me.role === Roles.Sar;
  }

  get isManagerUdn() {
    return this.me && this.me.role === Roles.ManagerUdn;
  }

  get isManagerVisualizer() {
    return this.me && this.me.role === Roles.ManagerVisualizer;
  }

  get links(): Link[] {
    return [
      {
        dropdown: true,
        show: this.isPlanner && !this.isParent,
        text: 'Nuevo',
        links: [
          {
            url: `/follows/${this.followId}/products/new`,
            text: 'Nuevo producto',
            show: this.isPlanner && !this.isParent
          },
          {
            url: `/follows/${this.followId}/products/import`,
            text: 'Cargar desde follow anterior',
            show: this.isPlanner && !this.isParent
          }
        ]
      },
      {
        url: `/follows/${this.followId}`,
        text: 'Productos',
        activeOptions: true,
        show: !this.isFood && !this.isCountryManager && !this.isComexCountry && !this.isManagerUdn && !this.isManagerVisualizer
      },
      {
        url: `/follows/${this.followId}/colors`,
        text: 'Colores',
        show:
          (this.isDesigner || this.isRegionalBuyer) &&
          !this.isParent &&
          !this.isFood
      },
      {
        url: `/follows/${this.followId}/kanban`,
        text: 'Estado de productos',
        show: this.isDesigner
      },
      {
        url: `/follows/${this.followId}/settings`,
        text: 'Configuración',
        show:
          this.isPlanner ||
          this.isRegionalBuyer ||
          (this.isMerchant && this.isParent)
      },
      {
        url: `/follows/${this.followId}/overview`,
        text: 'Resumen',
        show:
          !this.isComex &&
          !this.isSar &&
          !this.isQC &&
          !this.isSuperAdmin &&
          !this.isFood &&
          !this.isComexCountry
      },
      // {
      //   dropdown: true,
      //   show: true,
      //   text: 'Aprobación',
      //   links: [
      //     {
      //       url: `/follows/${this.followId}/approval/`,
      //       text: 'Caratula de Aprobación',
      //       show: true
      //     },
      //     {
      //       url: `/follows/${this.followId}/approval/list`,
      //       text: 'Listado de Aprobación',
      //       show: true
      //     }
      //   ]
      // },
      {
        url: `/follows/${this.followId}/showroom`,
        text: 'Showroom',
        show: false
      },
      {
        url: `/follows/${this.followId}/showroomFood`,
        text: 'Catálogo',
        show: this.hasPermission && !this.isManagerUdn && !this.isManagerVisualizer
      },
      {
        url: `/follows/${this.followId}/article-groups`,
        text: 'Grupos de artículos',
        show: false
      },
      // {
      //   url: `/follows/${this.followId}/country-overview`,
      //   text: 'Resumen',
      //   show: this.isCountryBuyer
      // },
      {
        url: `/follows/${this.followId}/download`,
        text: 'Cargar/Descargar',
        show:
          (this.isPlanner ||
            this.isRegionalBuyer ||
            this.isCountryBuyer ||
            this.isDesigner ||
            this.isComex ||
            this.isSar ||
            this.isQC ||
            this.isSuperAdmin ||
            this.isMerchant) &&
          ((this.isFood && !this.isCountryManager) || !this.isFood)
      },
      {
        url: `/follows/${this.followId}/proformas`,
        text: this.isCountryBuyer ? 'Cierre de embarques' : 'Proformas (Pz)',
        show:
          (this.isPlanner ||
            this.isRegionalBuyer ||
            this.isCountryBuyer ||
            this.isComex ||
            this.isSar ||
            this.isMerchant) &&
          !this.isParent &&
          !this.isFood
      },
      {
        url: `/follows/${this.followId}/discrepancies`,
        text: 'Discrepancias',
        show:
          (this.isPlanner ||
            this.isMerchant ||
            this.isRegionalBuyer ||
            this.isComex) &&
          this.isParent
        // && !this.hasArrival
      },
      {
        url: `/follows/${this.followId}/products/trash`,
        text: 'Papelera',
        show:
          (this.isPlanner || this.isRegionalBuyer || this.isDesigner) &&
          !this.isParent
      }
    ];
  }

  get hasPermission() {
    return (
      this.followType &&
      (this.followType === 'HOGAR' ||
        this.followType === 'FOOD' ||
        this.followType === 'PARIS HOGAR' ||
        this.followType === 'ALTELECTRO' ||
        this.followType === 'PARIS VESTUARIO' ||
        this.followType === 'VESTUARIO') &&
      !this.isComexCountry
    );
  }

  get hasArrival() {
    return (
      (this.follow && (this.follow.ArrivalState || this.follow.arrivals)) ||
      false
    );
  }

  get isFood() {
    return this.followType && this.followType === 'FOOD';
  }

  get isHome() {
    return this.followType && this.followType === 'HOGAR';
  }

  get isDesigner() {
    return this.me && this.me.role === Roles.Designer;
  }

  get isRegionalBuyer() {
    return (
      this.me && this.me.role && rolesUtils.isOnlyRegionalUser(this.me.role)
    );
  }

  get isRegionalAnalyst() {
    return this.me && this.me.role && rolesUtils.isRegionalAnalyst(this.me.role)
  }

  get isCountryBuyer() {
    return this.me && this.me.role && rolesUtils.isCountryUser(this.me.role);
  }

  get isQC() {
    return this.me && this.me.role && rolesUtils.isSupervisorQC(this.me.role);
  }

  get isSuperAdmin() {
    return this.me && this.me.role && rolesUtils.isSuperAdmin(this.me.role);
  }

  get isMerchant() {
    return this.me && this.me.role && rolesUtils.isMerchant(this.me.role);
  }

  get isParent() {
    return this.follow && !this.follow.ParentId;
  }

  get followId() {
    return this.follow && this.follow.id;
  }

  get description() {
    return this.follow && this.follow.description;
  }

  get followPlannerId() {
    return this.follow && this.follow.plannerId;
  }

  get followSeason() {
    return this.follow && this.follow.Season.name;
  }

  get followGroup() {
    return (
      this.follow && this.follow.followGroup && this.follow.followGroup.name
    );
  }

  get followDescription() {
    return this.follow && this.follow.description;
  }

  get followType() {
    return this.follow && this.follow.type;
  }

  get indexed() {
    return this.follow && this.follow.indexed;
  }

  get followYear() {
    return this.follow && this.follow.year;
  }

  get followName() {
    if (this.isParent) {
      return `${this.followId} - ${this.followGroup}-${this.followSeason}-${
        this.followYear
      } (${this.followType})`;
    } else {
      if (this.isFood && this.isCountryManager) {
        return `${this.followId} - ${this.followPlannerId}-${
          this.followYear
        } (${this.description || this.indexed})`;
      } else {
        return `${this.followId} - ${this.followPlannerId}-${
          this.followSeason
        }-${this.followYear} (${this.description || this.indexed})`;
      }
    }
  }

  get followDestination() {
    if (this.follow && this.follow.DestinationCenter) {
      return `${this.follow.Business.name} - ${
        this.follow.Business.Country.name
      } - ${this.follow.DestinationCenter.name}`;
    }
  }

  get statusName() {
    return this.follow && this.follow.statusName;
  }

  constructor() {}

  ngOnInit() {}

  trackLinks(index, item) {
    return item && item.text;
  }
}
